import Vue from 'vue'
import Router from 'vue-router'
import routeName from '@/router/routeNames'
import Page404 from '@/pages/Page404'
import PG_Login from '@/pages/Login'
import PG_QualificationData from '@/pages/public/QualificationData.vue'
import PG_Home from '../containers/DefaultContainer'
import PG_HomePublic from '../containers/PublicContainer.vue'
import PG_StatisticPublic from '@/pages/public/Statistic.vue'
import PG_Dashboard from '@/views/dashboard/Index'
import PG_User from '@/views/user/Index'
import PG_ApplicantList from '@/views/applicant/list/Index'
import PG_Applicant from '@/views/applicant/Index'
import PG_ApplicantBasic from '@/views/applicant/basic/Index'
import PG_ApplicantBasicView from '@/views/applicant/basic/View'
import PG_ApplicantNew from '@/views/applicant/new/Index'
import PG_RecognitionData from '@/views/applicant/recognition/Index'
import PG_RecognitionDecisionData from '@/views/applicant/recognition/Decision'
import PG_RecognitionEvaluationData from '@/views/applicant/recognition/Evaluation'
import PG_ApplicantDocument from '@/views/applicant/document/Index'
import PG_UserList from '@/views/user/list/Index'
import PG_InstitutionList from '@/views/institution/list/Index'
import PG_ContactList from '@/views/contact/list/Index'
import PG_ResetPassword from '@/pages/public/PasswordReset'
import PG_RecognitionDecisionDocument from '@/views/applicant/recognition/DecisionDocument'
import PG_LogList from '@/views/logs/list/index.vue'
import PG_PrivacyPolicy from '@/pages/public/PrivacyPolicy.vue'
import store from '@/store/store'
import * as r_permission from '@/shared/route_permission'
import { USER_DATA } from '@/shared/constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash, offset: { y: 100 } }
    return { x: 0, y: 0 }
  },
  routes: [

    {
      path: '/public',
      component: PG_HomePublic,
      children: [
        {
          path:'/qualification-data',
          name: routeName.RN_PUBLIC_QUALIFICATION_DATA,
          component: PG_QualificationData,
          meta: { public: true }
        },
        {
          path:'/statistic',
          name: routeName.RN_PUBLIC_STATISTIC,
          component: PG_StatisticPublic,
          meta: { public: true }
        },
        {
          path: '/login',
          name: routeName.RN_LOGIN,
          component: PG_Login,
          meta: { public: true }
        },
        {
          path: '/set-password',
          name: routeName.RN_RESET_PASSWORD,
          component: PG_ResetPassword,
          meta: { public: true }
        },
        {
          path: "/privacy-policy",
          name: routeName.RN_PRIVACY_POLICY,
          component:  PG_PrivacyPolicy,
          meta: { public: true }
        }
      ]
    },

    // PRIVATE (ADMIN) DIO – koristi DefaultContainer (PG_Home)
    {
      path: '/',
      name: routeName.RN_HOME,
      component: PG_Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          name: routeName.RN_DASHBOARD,
          component: PG_Dashboard,
          meta: { requiresAuth: true, /* permission_id: r_permission.R_DASHBOARD, */ t: 'DASHBOARD' },
        },
        {
          path: 'user-settings',
          name: routeName.RN_USER_SETTINGS,
          component: PG_User,
          meta: { requiresAuth: true, permission_id: r_permission.R_USER_SETTINGS },
        },
        {
          path: 'applicants',
          name: routeName.RN_APPLICANTS,
          component: PG_ApplicantList,
          meta: { requiresAuth: true, permission_id: r_permission.R_APPLICANTS, t: 'APPLICANTS' },
        },
        {
          path: 'applicant/new',
          name: routeName.RN_APPLICANT_NEW,
          component: PG_ApplicantNew,
          meta: { requiresAuth: true, permission_id: r_permission.R_APPLICANT_NEW },
        },
        {
          path: 'applicant/:id/basic-view',
          name: routeName.RN_APPLICANT_BASIC_VIEW,
          component: PG_ApplicantBasicView,
          meta: { requiresAuth: true, permission_id: r_permission.R_APPLICANT_BASIC_VIEW },
        },
        {
          path: 'applicant/:id',
          name: routeName.RN_APPLICANT,
          // bitno: redirect sa parametrima
          redirect: to => ({ name: routeName.RN_APPLICANT_BASIC, params: { id: to.params.id } }),
          component: PG_Applicant,
          meta: { requiresAuth: true, permission_id: r_permission.R_APPLICANT },
          children: [
            {
              path: 'basic',
              name: routeName.RN_APPLICANT_BASIC,
              component: PG_ApplicantBasic,
              meta: { requiresAuth: true, permission_id: r_permission.R_APPLICANT_BASIC },
            },
            {
              path: 'recognition-data',
              name: routeName.RN_RECOGNITION_DATA,
              component: PG_RecognitionData,
              meta: { requiresAuth: true, permission_id: r_permission.R_RECOGNITION_DATA },
            },
            {
              path: 'recognition-decision',
              name: routeName.RN_RECOGNITION_DECISION_DATA,
              component: PG_RecognitionDecisionData,
              meta: { requiresAuth: true, permission_id: null /*r_permission.R_RECOGNITION_DECISION_DATA */},
            },
            {
              path: 'recognition-evaluation',
              name: routeName.RN_RECOGNITION_EVALUATION_DATA,
              component: PG_RecognitionEvaluationData,
              meta: { requiresAuth: true, permission_id: null /*r_permission.R_RECOGNITION_EVALUATION_DATA*/ },
            },
            {
              path: 'documents',
              name: routeName.RN_APPLICANT_DOCUMENT,
              component: PG_ApplicantDocument,
              meta: { requiresAuth: true, permission_id: r_permission.R_APPLICANT_DOCUMENT },
            },
            {
              path: 'decision-document',
              name: routeName.RN_RECOGNITION_DECISION_DOCUMENT,
              component: PG_RecognitionDecisionDocument,
              meta: { requiresAuth: true, permission_id: r_permission.R_RECOGNITION_DECISION_DOCUMENT },
            },
          ],
        },
        {
          path: 'users',
          name: routeName.RN_USER_LIST,
          component: PG_UserList,
          meta: { requiresAuth: true, permission_id: r_permission.R_USER_LIST, t: 'USERS' },
        },
        {
          path: 'institutions',
          name: routeName.RN_INSTITUTIONS,
          component: PG_InstitutionList,
          meta: { requiresAuth: true, permission_id: r_permission.R_INSTITUTIONS, t: 'INSTITUTIONS' },
        },
        {
          path: 'contacts',
          name: routeName.RN_CONTACTS,
          component: PG_ContactList,
          meta: { requiresAuth: true, permission_id: r_permission.R_CONTACTS, t: 'CONTACTS' },
        },
        {
          path: 'logs',
          name: routeName.RN_LOGS,
          component: PG_LogList,
          meta: { requiresAuth: true, permission_id: r_permission.R_LOGS, t: 'LOGS' },
        },
      ],
    },

    { path: '*', component: Page404, meta: { public: true } },
  ],
})

// ———————————————————————————
// Route Guard
// ———————————————————————————
router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(r => r.meta && r.meta.public === true)
  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth)
  const userFromStore = store.getters['user/getUser']
  const userFromLS = (() => {
    try { return JSON.parse(localStorage.getItem(USER_DATA) || 'null') } catch (e) { return null }
  })()
  const isLoggedIn = !!(userFromStore || userFromLS)

  if (isPublic) {
    return next()
  }

  if (requiresAuth && !isLoggedIn) {
    return next({ name: routeName.RN_HOME_PUBLIC, query: { redirect: to.fullPath } })
  }


  const requiredPermission = to.matched
    .map(r => r.meta && r.meta.permission_id)
    .filter(Boolean)
    .pop()

  if (requiredPermission && !store.getters['user/getPermission'](requiredPermission)) {
    // nema pravo – idi na dashboard ili 404
    return next({ name: routeName.RN_DASHBOARD })
  }

  return next()
})

export default router
